export enum OnboardingState {
    DRAFT = 'DRAFT',
    REQUESTED = 'REQUESTED',
    IN_PROGRESS = 'IN_PROGRESS',
    SUBMITTED = 'SUBMITTED',
    CANCELED = 'CANCELED',
}
